import axios from 'axios'
const backend = 'https://api-dashboard.oned.io'
const backend2 = 'http://localhost:3000'
const currencyURL = 'https://api.exchangeratesapi.io/latest?base='
export default {
  /**
   * @return {string}
   */
  async MAIN_OVERVIEWS_WEEKLY_DATA({ commit, state }) {
      const data = await axios.get(`${backend}/overviews/getOneWeek`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      });
      if (data){
        commit('SET_ONE_WEEK_OVERVIEWS', data.data);
      }else{
        return 'Error!!';
      }
  },

  async MAIN_OVERVIEWS_3Day_DATA({ commit, state }) {
    const data = await axios.get(`${backend}/overviews/getThreeDay`,{
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      }
    });
    if (data){
      commit('SET_ONE_WEEK_OVERVIEWS', data.data);
    }else{
      return 'Error!!';
    }
},
async MAIN_OVERVIEWS_14Day_DATA({ commit, state }) {
  const data = await axios.get(`${backend}/overviews/getTwoWeek`,{
    headers:{
      Authorization: 'Bearer ' + $cookies.get('user'),
    }
  });
  if (data){
    commit('SET_ONE_WEEK_OVERVIEWS', data.data);
  }else{
    return 'Error!!';
  }
},
async MAIN_OVERVIEWS_MONTHLY_DATA({ commit, state }) {
  const data = await axios.get(`${backend}/overviews/getOneMonth`,{
    headers:{
      Authorization: 'Bearer ' + $cookies.get('user'),
    }
  });
  if (data){
    commit('SET_ONE_WEEK_OVERVIEWS', data.data);
  }else{
    return 'Error!!';
  }
},
async MAIN_OVERVIEWS_180Day_DATA({ commit, state }) {
  const data = await axios.get(`${backend}/overviews/getOneEighty`,{
    headers:{
      Authorization: 'Bearer ' + $cookies.get('user'),
    }
  });
  if (data){
    commit('SET_ONE_WEEK_OVERVIEWS', data.data);
  }else{
    return 'Error!!';
  }
},

async MAIN_OVERVIEWS_SEARCH_DATA({commit, state, getters},{date1,date2}) {
  const data = await axios.get(`${backend}/overviews/searchDates/${date1}/${date2}`,{
    headers:{
      Authorization: 'Bearer ' + $cookies.get('user'),
    }
  });
  if (data){
    commit('SET_ONE_WEEK_OVERVIEWS', data.data);
  }else{
    return 'Error!!';
  }
},
  async SET_MAIN_ITEMS_3Day({commit, state, getters}){
    const data = await axios.get(`${backend}/items/getThreeDay`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      });
    commit('SET_ITEMS_MAIN', data.data);
  },
  async SET_MAIN_ITEMS_WEEKLY({commit, state, getters}){
    const data = await axios.get(`${backend}/items/getOneWeek`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      });
    commit('SET_ITEMS_MAIN', data.data);
  },
  async SET_MAIN_ITEMS_14Day({commit, state, getters}){
    const data = await axios.get(`${backend}/items/getTwoWeek`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      });
    commit('SET_ITEMS_MAIN', data.data);
  },
  async SET_MAIN_ITEMS_MONTHLY({commit, state, getters}){
    const data = await axios.get(`${backend}/items/getOneMonth`,{
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      }
    });
    commit('SET_ITEMS_MAIN', data.data);
  },
  async SET_MAIN_ITEMS_180Day({commit, state, getters}){
    const data = await axios.get(`${backend}/items/getOneEighty`,{
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      }
    });
    commit('SET_ITEMS_MAIN', data.data);
  },
  async SET_MAIN_ITEMS_SEARCH({commit, state, getters},{date1,date2}){
    const data = await axios.get(`${backend}/items/searchDates/${date1}/${date2}`,{
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      },
    });
    commit('SET_ITEMS_MAIN', data.data);
  },
  async SET_TRAFFIC_DATA_3Day({commit, state, getters}){
    const data = await axios.get(`${backend}/traffic/getThreeDay`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      });
    commit('SET_ITEMS_TRAFFIC_DATA', data.data);
  },
  async SET_TRAFFIC_DATA_WEEKLY({commit, state, getters}){
    const data = await axios.get(`${backend}/traffic/getOneWeek`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      });
    commit('SET_ITEMS_TRAFFIC_DATA', data.data);
  },
  async SET_TRAFFIC_DATA_14Day({commit, state, getters}){
    const data = await axios.get(`${backend}/traffic/getTwoWeek`,{
        headers:{
          Authorization: 'Bearer ' + $cookies.get('user'),
        }
      });
    commit('SET_ITEMS_TRAFFIC_DATA', data.data);
  },
  async SET_TRAFFIC_DATA_MONTHLY({commit, state, getters}){
    const data = await axios.get(`${backend}/traffic/getOneMonth`,{
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      }
    });
    commit('SET_ITEMS_TRAFFIC_DATA', data.data);
  },
  async SET_TRAFFIC_DATA_180Day({commit, state, getters}){
    const data = await axios.get(`${backend}/traffic/getOneEighty`,{
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      }
    });
    commit('SET_ITEMS_TRAFFIC_DATA', data.data);
  },
  async SET_TRAFFIC_DATA_SEARCH({commit, state, getters},{date1,date2}){
    const data = await axios.get(`${backend}/traffic/searchDates/${date1}/${date2}`,{
      headers:{
        Authorization: 'Bearer ' + $cookies.get('user'),
      },
    });
    commit('SET_ITEMS_TRAFFIC_DATA', data.data);
  },

  async OPTIONS_CHART({commit},{label,service, data, site,currency}){
    commit('SET_CHARTOPTIONS_DATA',{label,service, data, site,currency})
  },
  async GENERAL_TOTAL({commit},data){
    commit('SET_GENERAL_TOTAL', data)
  },
  async CURRENCY({commit}){
    const dolar = await axios.get(`${currencyURL}USD`)
    const tl = await axios.get(`${currencyURL}TRY`)
    const ruble = await axios.get(`${currencyURL}RUB`)
    commit('SET_CURRENT_CURRENCY',{dolar,tl,ruble})
  },
  async SET_REQUEST({commit}){
    commit('SET_REQUEST', true)
  },
  async SET_ONEDIOCOM_OVERVIEWS({commit},{user,pageview,session,rate}){
    commit('SET_ONEDIOCOM_OVERVIEWS',{user,pageview,session,rate})
  },
  async SET_ONEDIOCO_OVERVIEWS({commit},{user,pageview,session,rate}){
    commit('SET_ONEDIOCO_OVERVIEWS',{user,pageview,session,rate})
  },
  async SET_ONEDIORU_OVERVIEWS({commit},{user,pageview,session,rate}){
    commit('SET_ONEDIORU_OVERVIEWS',{user,pageview,session,rate})
  },
  async SET_USERNAME({commit},username){
    commit('SET_USERNAME', username)
  },
  async OVERVIEW_CHART({commit},{overview,site}){
    commit('OVERVIEW_CHART',{overview,site})
  },
  async SET_SITE_SERVICE({commit},{site,service}){
    commit('SET_SITE_SERVICE',{site,service})
  },
  async SET_SEARCH_DATES({commit},{date1,date2}){
    commit('SET_SEARCH_DATE', {date1,date2})
  },
  async SET_BUTTON_ACTIVES({commit},data){
    commit('SET_BUTTON_ACTIVE',data)
  },
  /* async SET_CACHED_DATA({commit},data){
    commit('SET_CACHED_DATAS',data)
  }, */
  async RESET({commit},data){
    commit('RESET_ALL',data)
  },
}
